<template>

<app-panel-content :slim="true" :grow="true">

    <app-panel-title :text="item.name" :is-big="true" />
	
	<app-panel-summary label="Status" :tag="$constants.volunteers.role.statusName[item.status]" :status="$constants.volunteers.role.statusTheme[item.status]" :theme="$constants.volunteers.role.statusTheme[item.status]" />
		
    <app-panel-summary label="Reference" :value="item.reference" />
		
    <app-panel-summary label="Eligibility" :value="$constants.volunteers.role.eligibilityName[item.eligibility]" :note="$constants.volunteers.role.eligibilityDescription[item.eligibility]" />
		
    <app-panel-summary label="Type" :value="$constants.volunteers.role.typeName[item.type]" :note="$constants.volunteers.role.typeDescription[item.type]" />
		
    <app-panel-summary label="Days" :value="days" v-if="item.type === $constants.volunteers.role.type.schedule"  />
		
    <app-panel-summary label="Slots" :value="item.count.slots" v-if="item.type === $constants.volunteers.role.type.schedule" />
            
    <app-panel-summary label="Volunteers" :value="item.count.filled" />
            
    <app-panel-summary label="Capacity" :value="item.count.capacity" />

</app-panel-content>

</template>

<script>

export default {

    props: ['item', 'references'],

    computed: {
    
        days: function() {
        
            var days = []

            this.$_.each(this.item.days, function(day) {
            
                days.push(this.references.days[day])
            
            }.bind(this))

            return days.join(', ')
        
        }
    
    }

}

</script>

<style scoped>

</style>
